import type { FaireProductEntity } from "../../entity_types/product";

export const p_w27kn6yddg: FaireProductEntity = {
  token: "p_w27kn6yddg",
  type: "product",
  name: "At Home with Fragrance",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/289d70b9e86e56395942285055c5abf5ce8620c9bde4e1255d46290ec3b5e2d9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a1ce7a810ec8dfa5c0c183c5fe566b91eaedd75f48c57775347e7fa9e215f19.jpeg",
    "https://cdn.faire.com/fastly/45c38bdaa1dc79b4f848aef7cd1f7bc8f5b4a42d00f4d7db4dd09b8a60fda875.jpeg",
    "https://cdn.faire.com/fastly/5d0d95a2a8e23fd80a631ffdad433becb3726eeb3ba3b63ab89b52957d4fc3ca.jpeg",
  ],
  priceDollars: 12.25,
  description:
    'Sold in case packs of 6 units\nWholesale price: $12.25/unit\nRetail MSRP: $24.99/unit\n\nAt Home With Fragrance: Creating Modern Scents for Your Space, the first-ever book written by P.F. owners Kristen + Tom. In this book, you’ll learn how to enhance any space using home fragrance, then try your hand at making your very own via easy-to-follow DIYs.\n\n"Equal parts design and DIY, At Home with Fragrance will teach you which fragrances work best for each room, how to interpret your distinct design style into fragrance, and (the best part!) how to make candles, room sprays, and incense with your own custom scents. Filled with tips and recipes for room sprays, incense, candles, and more, the book unlocks the secrets of P.F.’s hallmark style—creating atmosphere with candles and scent—and helps readers make it their own."',
  tags: [],
  msrpDollars: 24.99,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-01T21:36:04.473Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
